import { render, staticRenderFns } from "./supplement-record.vue?vue&type=template&id=1b2f2be1&scoped=true&"
import script from "./supplement-record.vue?vue&type=script&lang=js&"
export * from "./supplement-record.vue?vue&type=script&lang=js&"
import style0 from "./supplement-record.vue?vue&type=style&index=0&id=1b2f2be1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2f2be1",
  null
  
)

export default component.exports